/* 
  TODO:
    Should extend Element class.

  Optional:
    Focus element after insterting it's first letter,
    seems to be optional W3C statement.
*/

import { Accessibility } from "~/src/accessibility/Accessibility";

export function initializeSimpleDropdown(){
  let dropdownButtons = $(".simple-dropdown-button")
  if (dropdownButtons.length > 0){
    dropdownButtons.on("click", function(){
      let content = $(".simple-dropdown-content")[0]
      content.classList.toggle("show");
      if ($(content).hasClass("show")){
        window.addEventListener("click", handleDropdownClose)
      }
      else {
        window.removeEventListener("click", handleDropdownClose)
      }
    })
  }
}

function handleDropdownClose(event){
  let clickedOnButton = event.target.matches('.simple-dropdown-button') || event.target.matches(".modern-cta-button-wrapper") || event.target.matches(".modern-cta-button__text")
  if (!clickedOnButton) {
    $(".simple-dropdown-content").each(function(){
      if (this.classList.contains('show')) {
        this.classList.remove('show');
        window.removeEventListener("click", handleDropdownClose)
      }
    })
  }
}

export class Dropdown {
  constructor(dropdownClass, parent) {
    this._container = dropdownClass;
    this._$container = $(dropdownClass);
    this._parent = parent;
    this._$parent = $(parent);

    this.initDropdowns();
    this.initDropdownInnerListNavigation();
    this.bindNoTargetClick();
  }

  get bareClass() {
    return this._container.slice(1);
  }

  get container() {
    return this._container;
  }

  get $container() {
    return this._$container;
  }

  get parent() {
    return this._parent;
  }

  get $parent() {
    return this._$parent;
  }

  initDropdowns() {
    this.$parent.on("click keydown", (e) => {
      this.openDropdown(e);
    });
  }

  initDropdownInnerListNavigation() {
    this.$container.on("keydown", (e) => {
      this.navigateDropdownList(e);
    });
  }

  openDropdown(event) {
    const $actualTarget = $(event.target).closest("a[aria-haspopup]").next("ul");
    const { DOWN, RETURN, SPACE, UP } = Accessibility.keyCodes;
    const toggle = () => {
      $actualTarget.toggleClass(this.bareClass + "--active");
      $(".header__bottom").toggleClass(".header__bottom--active");
      $actualTarget.slideToggle();
    };

    const actionTypes = {
      keydown: () => {
        if ([DOWN, RETURN, SPACE].indexOf(event.keyCode) > -1) {
          toggle();
          $actualTarget.find("a").first().focus();
        } else if (event.keyCode === UP) {
          toggle();
          $actualTarget.find("a").last().focus();
        }
      },

      click: () => {
        toggle();
      },

      default: () => {
        throw new Error(`Any of dropdown actions cannot be performed with such event type: ${event.type}`);
      },
    };

    const actionToPerform = actionTypes.hasOwnProperty(event.type) ? event.type : "default";
    const wasAlreadyOpened = $actualTarget.hasClass(this.bareClass + "--active");
    this.closeOpenedDropdowns(event);

    if (wasAlreadyOpened) return;
    actionTypes[actionToPerform]();
  }

  closeOpenedDropdowns(event = { type: "keydown", keyCode: Accessibility.keyCodes.ESC }) {
    const { ESC, RETURN, SPACE } = Accessibility.keyCodes;
    if (event.type === "keydown" && ![ESC, RETURN, SPACE].includes(event.keyCode)) return;

    if (
      $(event.target)
        .closest(this.container)
        .hasClass(this.bareClass + "--active")
    )
      return;

    const $dropdown = this.$parent.find(this.container + "--active");
    $dropdown.removeClass(this.bareClass + "--active");
    $(".header__bottom--active").removeClass(".header__bottom--active");
    $dropdown.slideUp();
  }

  navigateDropdownList(event) {
    const { LEFT, UP, RIGHT, DOWN, ESC } = Accessibility.keyCodes;
    let $nextItem, $lastItem, $resultTarget;
    switch (event.keyCode) {
      case UP:
        $nextItem = $(event.target).closest("li").next("li").children("a");
        $lastItem = $(event.target).closest("ul").children("li").first().find("a");
        break;

      case DOWN:
        $nextItem = $(event.target).closest("li").prev("li").children("a");
        $lastItem = $(event.target).closest("ul").children("li").last().find("a");
        break;

      case ESC:
        this.closeOpenedDropdowns();
        break;

      case LEFT:
        $nextItem = $(event.target).closest("ul").closest("li").prev("li").find("a");
        break;

      default:
        return;
    }
    $resultTarget = $nextItem.length ? $nextItem : $lastItem;
    $resultTarget.focus();
  }

  bindNoTargetClick() {
    $("body").on("click", (e) => {
      const isCorrectTarget = !!$(e.target).closest(this.parent).length;
      if (!isCorrectTarget) {
        this.closeOpenedDropdowns();
      }
    });
  }
}
